import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useEffect } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { useForm } from "react-hook-form";
import { crearOEditarActividad } from "../../services/actividades-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormActividades = ({ modalState, onSave }) => {
    const { actividad } = modalState.data;

    const defaultValues = {
        id: actividad.id == null ? "" : actividad.id,
        nombre: actividad.nombre != null ? actividad.nombre : "",
        color: actividad.color != null ? actividad.color : "#000000",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [actividad]);


    const onCreateActividad = async (actividad) => {
        const resp = await crearOEditarActividad({
            ...actividad,

        });

        if (!resp.status) return toast.error(resp.message);
        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formActividades"
            onSubmit={onCreateActividad}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={8}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre del area"
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        type="color"
                        label="Color"
                        errors={form.formState.errors}
                        control={form.control}
                        name="color"
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormActividades.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
};

export default FormActividades;
